import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "43",
  height: "43",
  viewBox: "0 0 43 43",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.52373 34.8271C10.6136 32.2593 13.1583 30.4583 16.1237 30.4583H26.8737C29.839 30.4583 32.3837 32.2593 33.4737 34.8271M28.6654 17.0208C28.6654 20.9789 25.4567 24.1875 21.4987 24.1875C17.5407 24.1875 14.332 20.9789 14.332 17.0208C14.332 13.0628 17.5407 9.85415 21.4987 9.85415C25.4567 9.85415 28.6654 13.0628 28.6654 17.0208ZM39.4154 21.5C39.4154 31.3951 31.3938 39.4166 21.4987 39.4166C11.6036 39.4166 3.58203 31.3951 3.58203 21.5C3.58203 11.6049 11.6036 3.58331 21.4987 3.58331C31.3938 3.58331 39.4154 11.6049 39.4154 21.5Z",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }